import classNames from 'classnames'
import React, {ReactNode} from 'react'

import Icon from '../icons/Icon'
import {TooltipPosition, TooltipWrapper} from './TooltipWrapper'

export type TooltipTypes = 'primary' | 'secondary';

export interface TooltipProps {
  text: string;
  position?: TooltipPosition;
  type?: TooltipTypes;
  showIcon?: boolean;
  children?: ReactNode;
}

const Tooltip = ({text, position = 'top', type = 'primary', children}: TooltipProps) => {
  const baseClasses = classNames({
    '-top-1 left-12 transform -translate-y-full -translate-x-1/2': position === 'top',
    '-bottom-1 left-12 transform translate-y-full -translate-x-1/2': position === 'bottom',
    'left-8 top-3 transform -translate-y-1/2': position === 'right',
    'right-8 top-3 transform -translate-y-1/2': position === 'left'
  })

  const contentClasses = classNames('rounded-lg p-4 text-sm', {
    'bg-kwota-neutral-700 text-white w-56': type === 'primary',
    'bg-white shadow-lg w-[190px]': type === 'secondary'
  })

  const getHoverable = () => {
    if (children) {
      return children
    } else {
      return (
        <Icon
          icon="question"
          className="w-6 h-6 ml-1 cursor-pointer fill-kwota-neutral-800"
        />
      )
    }
  }

  return (
    <TooltipWrapper
      baseClasses={baseClasses}
      hoverable={getHoverable()}
    >
      <div className={contentClasses}>
        {text}
      </div>
    </TooltipWrapper>
  )
}

export default Tooltip
